








































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Autocomplete } from 'element-ui';
import sheets from '../../sheets.json';

@Component({
  components: {
    'el-autocomplete': Autocomplete,
  },
})
export default class FindByNameWidget extends Vue {
    @Prop() private scale!: number;

    private s100values: string[] = [];

    private sheet: any = {
      s250: '',
      s100: '',
      s50: '',
      s25: '',
      s10: '',
      s5: '',
      s2: '',
      s1: '',
    };

    private searchS250(queryString: string, cb: any): void {
      if (queryString) {
          const result = sheets
                            .filter((s) =>
                                          s.name.toLocaleLowerCase('tr')
                                          .indexOf(queryString.toLocaleLowerCase('tr')) > -1)
                            .map((s) => ({value: s.name, s100s: s.s100s}));
          cb(result);
      }
    }

    private handleSelect250(selection: any) {
      this.s100values = selection.s100s;
    }

    get s25values() {
      const result = [];
      for (let i = 1; i <= 4; i++) {
        result.push(`${this.sheet.s50}${i}`);
      }
      return result;
    }

    get s10values() {
      const result = [];
      for (let i = 1; i <= 25; i++) {
        result.push((i < 10) ? '0' + i : i);
      }
      return result;
    }

    private find(): void {
      const sheet = Object.keys(this.sheet)
                        .filter((k) => (Number(k.substring(1)) === 25 && this.scale === 25) ||
                                       (Number(k.substring(1)) === 50 && this.scale !== 25) ||
                                       (Number(k.substring(1)) >= this.scale &&
                                        Number(k.substring(1)) !== 25 &&
                                        Number(k.substring(1)) !== 50))
                        .filter((k) => this.sheet[k].toString().length > 0).map((k) => this.sheet[k]).join('-');
      this.$emit('onFind', sheet);
    }
}
